import type { FC } from 'react';
import React, { createContext, useContext } from 'react';
import { createFeature } from '@edreamsodigeo/frontend-core';

import {
  PAYMENT_METHODS_IFRAME_D,
  PAYMENT_METHODS_IFRAME_M,
} from '@/versionedComponents';
import { useFlowTools } from '@/flowTools/useFlowTools';

const ACTIVE_PAYMENT_FORM_IFRAME_CONFIG = {
  enabled: true,
};

const INACTIVE_PAYMENT_FORM_IFRAME_CONFIG = {
  enabled: false,
};

const PaymentFormIframeConfig = createContext<{
  enabled: boolean;
}>(INACTIVE_PAYMENT_FORM_IFRAME_CONFIG);

const PaymentFormIframeA: FC = ({ children }) => {
  return (
    <PaymentFormIframeConfig.Provider
      value={INACTIVE_PAYMENT_FORM_IFRAME_CONFIG}
    >
      {children}
    </PaymentFormIframeConfig.Provider>
  );
};

const PaymentFormIframeB: FC = ({ children }) => {
  return (
    <PaymentFormIframeConfig.Provider value={ACTIVE_PAYMENT_FORM_IFRAME_CONFIG}>
      {children}
    </PaymentFormIframeConfig.Provider>
  );
};

export const usePaymentFormIframeConfig = (): {
  enabled: boolean;
} => useContext(PaymentFormIframeConfig);

const PaymentFormIframeDesktop = createFeature({
  name: PAYMENT_METHODS_IFRAME_D,
  variations: [PaymentFormIframeA, PaymentFormIframeB],
  version: 1,
});

const PaymentFormIframeMobile = createFeature({
  name: PAYMENT_METHODS_IFRAME_M,
  variations: [PaymentFormIframeA, PaymentFormIframeB],
  version: 1,
});

const PaymentFormIframeConfigAB: FC = ({ children }) => {
  const { isMobile } = useFlowTools();
  const PaymentConfigComponent = isMobile
    ? PaymentFormIframeMobile
    : PaymentFormIframeDesktop;

  return <PaymentConfigComponent>{children}</PaymentConfigComponent>;
};

export default PaymentFormIframeConfigAB;
